jQuery(document).ready(function($) {
    
    // Initialize Select2 on the evidence domain dropdown
    $('#evidenceDomain').select2({
        placeholder: "Select",
        width: '100%',
        dropdownParent: $('#newEvidenceModal'),
        allowClear: true,
        multiple: true
    });
    
    // Initialize Select2 on the evidence type dropdown
    $('#evidenceType').select2({
        placeholder: "Select",
        width: '100%',
        dropdownParent: $('#newEvidenceModal'),
        allowClear: true,
        multiple: true
    });

    // Initialize Select2 on the evidence owner dropdown
    $('#evidenceOwner').select2({
        placeholder: "Select",
        width: '100%',
        dropdownParent: $('#newEvidenceModal'),
        allowClear: false,
        minimumResultsForSearch: Infinity // Hide search box
    });

    // Initialize Select2 on the expiration schedule dropdown
    $('#expirationSchedule').select2({
        placeholder: "Select",
        width: '100%',
        dropdownParent: $('#newEvidenceModal'),
        allowClear: false,
        minimumResultsForSearch: Infinity // Hide search box
    });

    // Initialize Select2 on the associated projects dropdown
    $('#associatedProjects').select2({
        placeholder: "Select assessment(s)",
        width: '100%',
        dropdownParent: $('#associatedProjects').parent(),
        allowClear: true,
        multiple: true,
        dropdownPosition: 'below'
    });
    
    // Force placeholder to show for multiselects
    setTimeout(function() {
        // Handle Evidence Domain placeholder
        const $evidenceDomainSelect = $('#evidenceDomain');
        $evidenceDomainSelect.val(null).trigger('change');
        
        // For multiselect, manually add placeholder text to the selection container
        const $domainContainer = $evidenceDomainSelect.siblings('.select2-container');
        const $domainSelection = $domainContainer.find('.select2-selection--multiple');
        
        // Check if there's already placeholder content
        if ($domainSelection.find('.select2-selection__choice').length === 0) {
            // Add placeholder styling and text
            $domainSelection.addClass('select2-selection--placeholder');
            
            // Create and add placeholder element if it doesn't exist
            let $placeholder = $domainSelection.find('.select2-selection__placeholder');
            if ($placeholder.length === 0) {
                $placeholder = $('<span class="select2-selection__placeholder">Select</span>');
                $domainSelection.prepend($placeholder);
            } else {
                $placeholder.text('Select').show();
            }
        }
        
        // Handle Evidence Type placeholder
        const $evidenceTypeSelect = $('#evidenceType');
        $evidenceTypeSelect.val(null).trigger('change');
        
        const $typeContainer = $evidenceTypeSelect.siblings('.select2-container');
        const $typeSelection = $typeContainer.find('.select2-selection--multiple');
        
        if ($typeSelection.find('.select2-selection__choice').length === 0) {
            $typeSelection.addClass('select2-selection--placeholder');
            
            let $placeholder = $typeSelection.find('.select2-selection__placeholder');
            if ($placeholder.length === 0) {
                $placeholder = $('<span class="select2-selection__placeholder">Select</span>');
                $typeSelection.prepend($placeholder);
            } else {
                $placeholder.text('Select').show();
            }
        }

        // Handle Associated Projects placeholder
        const $associatedProjectsSelect = $('#associatedProjects');
        $associatedProjectsSelect.val(null).trigger('change');
        
        const $projectsContainer = $associatedProjectsSelect.siblings('.select2-container');
        const $projectsSelection = $projectsContainer.find('.select2-selection--multiple');
        
        if ($projectsSelection.find('.select2-selection__choice').length === 0) {
            $projectsSelection.addClass('select2-selection--placeholder');
            
            let $placeholder = $projectsSelection.find('.select2-selection__placeholder');
            if ($placeholder.length === 0) {
                $placeholder = $('<span class="select2-selection__placeholder">Select assessment(s)</span>');
                $projectsSelection.prepend($placeholder);
            } else {
                $placeholder.text('Select assessment(s)').show();
            }
        }
    }, 100);

    // Ensure placeholder shows when modal opens
    $('#newEvidenceModal').on('show.bs.modal', function () {
        console.log('Modal is about to show');
    });
    
    $('#newEvidenceModal').on('shown.bs.modal', function () {
        console.log('Modal shown, clearing evidenceDomain and evidenceType values');
        
        // Clear Evidence Domain
        console.log('EvidenceDomain element found:', $('#evidenceDomain').length > 0);
        console.log('EvidenceDomain has Select2:', $('#evidenceDomain').hasClass('select2-hidden-accessible'));
        
        const $evidenceDomainSelect = $('#evidenceDomain');
        const $domainContainer = $evidenceDomainSelect.closest('.select-wrapper, .evidence-domain');
        
        // Remove has-selections class when modal opens
        console.log('Removing has-selections class for evidenceDomain when modal opens');
        $domainContainer.removeClass('has-selections');
        
        $evidenceDomainSelect.val(null).trigger('change');
        console.log('EvidenceDomain value after clearing:', $evidenceDomainSelect.val());
        
        // Clear Evidence Type
        console.log('EvidenceType element found:', $('#evidenceType').length > 0);
        console.log('EvidenceType has Select2:', $('#evidenceType').hasClass('select2-hidden-accessible'));
        
        const $evidenceTypeSelect = $('#evidenceType');
        const $typeContainer = $evidenceTypeSelect.closest('.select-wrapper, .evidence-type');
        
        // Remove has-selections class when modal opens
        console.log('Removing has-selections class for evidenceType when modal opens');
        $typeContainer.removeClass('has-selections');
        
        $evidenceTypeSelect.val(null).trigger('change');
        console.log('EvidenceType value after clearing:', $evidenceTypeSelect.val());

        // Clear Associated Projects
        console.log('AssociatedProjects element found:', $('#associatedProjects').length > 0);
        console.log('AssociatedProjects has Select2:', $('#associatedProjects').hasClass('select2-hidden-accessible'));
        
        const $associatedProjectsSelect = $('#associatedProjects');
        const $projectsContainer = $associatedProjectsSelect.closest('.select-wrapper, .associated-projects');
        
        // Remove has-selections class when modal opens
        console.log('Removing has-selections class for associatedProjects when modal opens');
        $projectsContainer.removeClass('has-selections');
        
        $associatedProjectsSelect.val(null).trigger('change');
        console.log('AssociatedProjects value after clearing:', $associatedProjectsSelect.val());
        
        // Force placeholder to show for multiselects
        setTimeout(function() {
            // Handle Evidence Domain placeholder
            const $domainContainer = $evidenceDomainSelect.siblings('.select2-container');
            const $domainSelection = $domainContainer.find('.select2-selection--multiple');
            
            // Remove any existing selections and show placeholder
            $domainSelection.find('.select2-selection__choice').remove();
            
            if ($domainSelection.find('.select2-selection__choice').length === 0) {
                console.log('No selections found in modal, adding placeholder for evidenceDomain');
                $domainSelection.addClass('select2-selection--placeholder');
                
                let $placeholder = $domainSelection.find('.select2-selection__placeholder');
                if ($placeholder.length === 0) {
                    console.log('Creating placeholder element in modal for evidenceDomain');
                    $placeholder = $('<span class="select2-selection__placeholder">Select</span>');
                    $domainSelection.prepend($placeholder);
                } else {
                    console.log('Updating existing placeholder in modal for evidenceDomain');
                    $placeholder.text('Select').show();
                }
            }
            
            // Handle Evidence Type placeholder
            const $typeContainer = $evidenceTypeSelect.siblings('.select2-container');
            const $typeSelection = $typeContainer.find('.select2-selection--multiple');
            
            // Remove any existing selections and show placeholder
            $typeSelection.find('.select2-selection__choice').remove();
            
            if ($typeSelection.find('.select2-selection__choice').length === 0) {
                console.log('No selections found in modal, adding placeholder for evidenceType');
                $typeSelection.addClass('select2-selection--placeholder');
                
                let $placeholder = $typeSelection.find('.select2-selection__placeholder');
                if ($placeholder.length === 0) {
                    console.log('Creating placeholder element in modal for evidenceType');
                    $placeholder = $('<span class="select2-selection__placeholder">Select</span>');
                    $typeSelection.prepend($placeholder);
                } else {
                    console.log('Updating existing placeholder in modal for evidenceType');
                    $placeholder.text('Select').show();
                }
            }

            // Handle Associated Projects placeholder
            const $projectsContainer = $associatedProjectsSelect.siblings('.select2-container');
            const $projectsSelection = $projectsContainer.find('.select2-selection--multiple');
            
            // Remove any existing selections and show placeholder
            $projectsSelection.find('.select2-selection__choice').remove();
            
            if ($projectsSelection.find('.select2-selection__choice').length === 0) {
                console.log('No selections found in modal, adding placeholder for associatedProjects');
                $projectsSelection.addClass('select2-selection--placeholder');
                
                let $placeholder = $projectsSelection.find('.select2-selection__placeholder');
                if ($placeholder.length === 0) {
                    console.log('Creating placeholder element in modal for associatedProjects');
                    $placeholder = $('<span class="select2-selection__placeholder">Select assessment(s)</span>');
                    $projectsSelection.prepend($placeholder);
                } else {
                    console.log('Updating existing placeholder in modal for associatedProjects');
                    $placeholder.text('Select assessment(s)').show();
                }
            }
        }, 100);
    });

    // Handle Associated Projects Select2 events
    $('#associatedProjects').on('select2:select select2:unselect', function(e) {
        const $this = $(this);
        const $container = $this.siblings('.select2-container');
        const $selection = $container.find('.select2-selection--multiple');
        const $placeholder = $selection.find('.select2-selection__placeholder');
        
        // Hide placeholder when selections are made
        if ($this.val() && $this.val().length > 0) {
            $placeholder.hide();
            $selection.removeClass('select2-selection--placeholder');
        } else {
            // Show placeholder when no selections
            $placeholder.show();
            $selection.addClass('select2-selection--placeholder');
        }
    });

    // Handle "All" option behavior for evidence domains
    $('#evidenceDomain').on('select2:select select2:unselect', function(e) {
        console.log('Select2 event triggered:', e.type);
        console.log('Selected/unselected value:', e.params.data.id);
        console.log('Current values before processing:', $(this).val());
        
        const $this = $(this);
        const selectedValue = e.params.data.id;
        const $container = $this.closest('.select-wrapper, .evidence-domain');
        
        // Prevent recursive calls
        if ($this.data('programmatic-change')) {
            console.log('Skipping due to programmatic change flag');
            return;
        }
        
        console.log('Setting programmatic-change flag to true');
        $this.data('programmatic-change', true);
        
        if (selectedValue === 'all') {
            console.log('"All" option was selected/unselected');
            if (e.type === 'select2:select') {
                console.log('Processing "All" selection');
                // "All" was selected - select all individual options
                const allOptions = $this.find('option').not('[value="all"]');
                console.log('Found individual options:', allOptions.length);
                
                const allValues = ['all'];
                allOptions.each(function() {
                    const optionValue = $(this).val();
                    console.log('Adding option value:', optionValue);
                    allValues.push(optionValue);
                });
                
                console.log('Setting all values:', allValues);
                $this.val(allValues).trigger('change.select2');
                console.log('Values after setting all:', $this.val());
                
                // Add has-selections class when "All" is selected
                console.log('Adding has-selections class - "All" selected');
                $container.addClass('has-selections');
            } else {
                console.log('"All" was unselected - this case is handled by individual logic');
            }
        } else {
            console.log('Individual option was selected/unselected:', selectedValue);
            // An individual option was selected/unselected
            const currentValues = $this.val() || [];
            console.log('Current values:', currentValues);
            
            const allOptions = $this.find('option').not('[value="all"]');
            const allOptionValues = allOptions.map(function() {
                return $(this).val();
            }).get();
            console.log('All available option values:', allOptionValues);
            
            if (e.type === 'select2:select') {
                console.log('Individual option was selected');
                // Check if all individual options are now selected
                const individualSelected = currentValues.filter(val => val !== 'all');
                console.log('Individual options selected:', individualSelected);
                console.log('Total individual options available:', allOptionValues.length);
                
                if (individualSelected.length === allOptionValues.length) {
                    console.log('All individual options are selected, adding "All"');
                    // Add "All" to the selection
                    if (!currentValues.includes('all')) {
                        const newValues = ['all'].concat(currentValues);
                        console.log('Setting new values with "All":', newValues);
                        $this.val(newValues).trigger('change.select2');
                        console.log('Values after adding "All":', $this.val());
                    } else {
                        console.log('"All" is already selected');
                    }
                } else {
                    console.log('Not all individual options are selected yet');
                }
                
                // Add has-selections class when any individual option is selected
                console.log('Adding has-selections class - individual selection made');
                $container.addClass('has-selections');
            } else {
                console.log('Individual option was unselected');
                // An individual option was unselected - remove "All" if it's selected
                if (currentValues.includes('all')) {
                    console.log('Removing "All" since not all individual options are selected');
                    const newValues = currentValues.filter(val => val !== 'all');
                    console.log('Setting new values without "All":', newValues);
                    $this.val(newValues).trigger('change.select2');
                    console.log('Values after removing "All":', $this.val());
                } else {
                    console.log('"All" is not selected, no need to remove it');
                }
                
                // Check if we should remove has-selections class
                const remainingValues = $this.val() || [];
                if (remainingValues.length === 0) {
                    console.log('Removing has-selections class - no selections remaining');
                    $container.removeClass('has-selections');
                } else {
                    console.log('Keeping has-selections class - selections still remain');
                }
            }
        }
        
        console.log('Setting programmatic-change flag to false');
        $this.data('programmatic-change', false);
        console.log('Final values:', $this.val());
        console.log('--- End of select2 event processing ---');
    });

    // Handle "All" option behavior for evidence types
    $('#evidenceType').on('select2:select select2:unselect', function(e) {
        console.log('Select2 event triggered for evidenceType:', e.type);
        console.log('Selected/unselected value:', e.params.data.id);
        console.log('Current values before processing:', $(this).val());
        
        const $this = $(this);
        const selectedValue = e.params.data.id;
        const $container = $this.closest('.select-wrapper, .evidence-type');
        
        // Prevent recursive calls
        if ($this.data('programmatic-change')) {
            console.log('Skipping due to programmatic change flag');
            return;
        }
        
        console.log('Setting programmatic-change flag to true for evidenceType');
        $this.data('programmatic-change', true);
        
        if (selectedValue === 'all') {
            console.log('"All" option was selected/unselected for evidenceType');
            if (e.type === 'select2:select') {
                console.log('Processing "All" selection for evidenceType');
                // "All" was selected - select all individual options except "Other"
                const allOptions = $this.find('option').not('[value="all"]');
                console.log('Found individual type options:', allOptions.length);
                
                const allValues = ['all'];
                allOptions.each(function() {
                    const optionValue = $(this).val();
                    const optionText = $(this).text();
                    // Exclude "Other" from "All" selection
                    if (optionText.toLowerCase() !== 'other') {
                        console.log('Adding type option value:', optionValue);
                        allValues.push(optionValue);
                    } else {
                        console.log('Skipping "Other" option from "All" selection');
                    }
                });
                
                console.log('Setting all type values (excluding Other):', allValues);
                $this.val(allValues).trigger('change.select2');
                console.log('Type values after setting all:', $this.val());
                
                // Add has-selections class when "All" is selected
                console.log('Adding has-selections class - "All" type selected');
                $container.addClass('has-selections');
            } else {
                console.log('"All" was unselected for evidenceType - this case is handled by individual logic');
            }
        } else {
            console.log('Individual type option was selected/unselected:', selectedValue);
            // An individual option was selected/unselected
            const currentValues = $this.val() || [];
            console.log('Current type values:', currentValues);
            
            const allOptions = $this.find('option').not('[value="all"]');
            const allOptionValues = allOptions.map(function() {
                const optionText = $(this).text();
                // Exclude "Other" from the count for "All" logic
                if (optionText.toLowerCase() !== 'other') {
                    return $(this).val();
                }
                return null;
            }).get().filter(val => val !== null);
            console.log('All available type option values (excluding Other):', allOptionValues);
            
            if (e.type === 'select2:select') {
                console.log('Individual type option was selected');
                // Check if all individual options (except "Other") are now selected
                const individualSelected = currentValues.filter(val => val !== 'all');
                console.log('Individual type options selected:', individualSelected);
                console.log('Total individual type options available (excluding Other):', allOptionValues.length);
                
                // Count how many of the selected values are in our "all" list (excluding "Other")
                const relevantSelected = individualSelected.filter(val => allOptionValues.includes(val));
                console.log('Relevant type options selected (excluding Other):', relevantSelected);
                
                if (relevantSelected.length === allOptionValues.length) {
                    console.log('All individual type options (excluding Other) are selected, adding "All"');
                    // Add "All" to the selection
                    if (!currentValues.includes('all')) {
                        const newValues = ['all'].concat(currentValues);
                        console.log('Setting new type values with "All":', newValues);
                        $this.val(newValues).trigger('change.select2');
                        console.log('Type values after adding "All":', $this.val());
                    } else {
                        console.log('"All" is already selected for evidenceType');
                    }
                } else {
                    console.log('Not all individual type options (excluding Other) are selected yet');
                }
                
                // Add has-selections class when any individual option is selected
                console.log('Adding has-selections class - individual type selection made');
                $container.addClass('has-selections');
            } else {
                console.log('Individual type option was unselected');
                // An individual option was unselected - remove "All" if it's selected
                if (currentValues.includes('all')) {
                    console.log('Removing "All" from evidenceType since not all individual options are selected');
                    const newValues = currentValues.filter(val => val !== 'all');
                    console.log('Setting new type values without "All":', newValues);
                    $this.val(newValues).trigger('change.select2');
                    console.log('Type values after removing "All":', $this.val());
                } else {
                    console.log('"All" is not selected for evidenceType, no need to remove it');
                }
                
                // Check if we should remove has-selections class
                const remainingValues = $this.val() || [];
                if (remainingValues.length === 0) {
                    console.log('Removing has-selections class - no type selections remaining');
                    $container.removeClass('has-selections');
                } else {
                    console.log('Keeping has-selections class - type selections still remain');
                }
            }
        }
        
        console.log('Setting programmatic-change flag to false for evidenceType');
        $this.data('programmatic-change', false);
        console.log('Final type values:', $this.val());
        console.log('--- End of evidenceType select2 event processing ---');
    });

    // Calculate expiration date when schedule changes
    $('#expirationSchedule').on('change', function() {
        console.log('Expiration schedule changed, value:', $(this).val());
        const selectedValue = $(this).val();
        
        if (selectedValue === 'custom') {
            // Show custom date picker and set its value to today's date
            const today = new Date().toISOString().split('T')[0];
            $('#customExpirationDate').val(today);
            $('.evidence-custom-expiration').show();
            $('input[name="expirationDate"]').val(today);
            console.log('Custom expiration date picker shown, value set to:', today);
        } else {
            // Hide custom date picker
            $('.evidence-custom-expiration').hide();
            
            // Calculate expiration date based on selected days
            var days = parseInt(selectedValue);
            console.log('Parsed days:', days);
            
            // Only calculate if we have a valid number
            if (!isNaN(days) && days > 0) {
                var expirationDate = new Date();
                expirationDate.setDate(expirationDate.getDate() + days);
                var formattedDate = expirationDate.toISOString().split('T')[0];
                console.log('Calculated expiration date:', formattedDate);
                $('input[name="expirationDate"]').val(formattedDate);
            } else {
                console.log('Invalid days value, clearing expiration date');
                $('input[name="expirationDate"]').val('');
            }
        }
    });

    // Handle custom expiration date changes
    $('#customExpirationDate').on('change', function() {
        const customDate = $(this).val();
        console.log('Custom expiration date changed:', customDate);
        $('input[name="expirationDate"]').val(customDate);
    });
    
    // Reset form and Select2 when modal is closed
    $('#newEvidenceModal').on('hidden.bs.modal', function () {
        console.log('Modal hidden, resetting form');
        
        // Reset form first
        $('#newEvidenceForm').trigger('reset');
        console.log('Form reset triggered');
        
        // Clear evidenceDomain thoroughly
        const $evidenceDomain = $('#evidenceDomain');
        const $domainContainer = $evidenceDomain.closest('.select-wrapper, .evidence-domain');
        console.log('Clearing evidenceDomain selection');
        
        // Remove has-selections class during reset
        console.log('Removing has-selections class for evidenceDomain during modal reset');
        $domainContainer.removeClass('has-selections');
        
        // Clear all options' selected state and set value to null
        $evidenceDomain.find('option').prop('selected', false);
        $evidenceDomain.val(null);
        console.log('EvidenceDomain value after manual clearing:', $evidenceDomain.val());
        
        // Clear evidenceType thoroughly
        const $evidenceType = $('#evidenceType');
        const $typeContainer = $evidenceType.closest('.select-wrapper, .evidence-type');
        console.log('Clearing evidenceType selection');
        
        // Remove has-selections class during reset
        console.log('Removing has-selections class for evidenceType during modal reset');
        $typeContainer.removeClass('has-selections');
        
        // Clear all options' selected state and set value to null
        $evidenceType.find('option').prop('selected', false);
        $evidenceType.val(null);
        console.log('EvidenceType value after manual clearing:', $evidenceType.val());
        
        // Clear evidenceOwner dropdown
        $('#evidenceOwner').val('').trigger('change');
        
        // Clear expiration schedule dropdown
        $('#expirationSchedule').val('').trigger('change');

        // Hide custom expiration date field
        $('.evidence-custom-expiration').hide();
        
        // Hide auto-assignment preview and uncheck the checkbox
        $('#autoAssignmentPreview').hide();
        $('#autoAssignProjectUsers').prop('checked', false);
        
        // Clear file list and reset file input
        $('#newEvidenceFileList').empty();
        $('#evidenceFile').val('');
        
        // Update Select2 and show placeholders
        if ($evidenceDomain.data('select2')) {
            console.log('Updating Select2 after clearing evidenceDomain');
            $evidenceDomain.trigger('change.select2');
        }
        
        if ($evidenceType.data('select2')) {
            console.log('Updating Select2 after clearing evidenceType');
            $evidenceType.trigger('change.select2');
        }
        
        // Force placeholders to show
        setTimeout(function() {
            // Handle Evidence Domain placeholder
            const $domainContainer = $evidenceDomain.siblings('.select2-container');
            const $domainSelection = $domainContainer.find('.select2-selection--multiple');
            
            // Remove any existing selections
            $domainSelection.find('.select2-selection__choice').remove();
            $domainSelection.addClass('select2-selection--placeholder');
            
            let $domainPlaceholder = $domainSelection.find('.select2-selection__placeholder');
            if ($domainPlaceholder.length === 0) {
                console.log('Creating placeholder element in reset for evidenceDomain');
                $domainPlaceholder = $('<span class="select2-selection__placeholder">Select</span>');
                $domainSelection.prepend($domainPlaceholder);
            } else {
                console.log('Updating existing placeholder in reset for evidenceDomain');
                $domainPlaceholder.text('Select').show();
            }
            
            // Handle Evidence Type placeholder
            const $typeContainer = $evidenceType.siblings('.select2-container');
            const $typeSelection = $typeContainer.find('.select2-selection--multiple');
            
            // Remove any existing selections
            $typeSelection.find('.select2-selection__choice').remove();
            $typeSelection.addClass('select2-selection--placeholder');
            
            let $typePlaceholder = $typeSelection.find('.select2-selection__placeholder');
            if ($typePlaceholder.length === 0) {
                console.log('Creating placeholder element in reset for evidenceType');
                $typePlaceholder = $('<span class="select2-selection__placeholder">Select</span>');
                $typeSelection.prepend($typePlaceholder);
            } else {
                console.log('Updating existing placeholder in reset for evidenceType');
                $typePlaceholder.text('Select').show();
            }
            
            console.log('Select2 placeholders restored in reset');
        }, 100);
        
        console.log('Modal reset complete');
    });

    // Add event handler to manage placeholder visibility and has-selections class when selections change
    $('#evidenceDomain').on('change', function() {
        const $select = $(this);
        const selectedValues = $select.val() || [];
        const $container = $select.closest('.select-wrapper, .evidence-domain');
        
        // Manage has-selections class
        // Consider it as having selections if there are any actual domain selections (not just empty)
        // When "All" is selected, selectedValues will contain both "all" and actual domain IDs
        const hasActualSelections = selectedValues.length > 0 && 
            (selectedValues.some(val => val !== 'all') || selectedValues.includes('all'));
        
        if (hasActualSelections) {
            console.log('Adding has-selections class - valid domain selections made');
            $container.addClass('has-selections');
        } else {
            console.log('Removing has-selections class - no valid domain selections');
            $container.removeClass('has-selections');
        }
        
        setTimeout(function() {
            const $container = $select.siblings('.select2-container');
            const $selection = $container.find('.select2-selection--multiple');
            const $placeholder = $selection.find('.select2-selection__placeholder');
            
            if (selectedValues.length === 0) {
                // No selections - show placeholder
                console.log('No domain selections, showing placeholder');
                $selection.addClass('select2-selection--placeholder');
                if ($placeholder.length === 0) {
                    const $newPlaceholder = $('<span class="select2-selection__placeholder">Select</span>');
                    $selection.prepend($newPlaceholder);
                } else {
                    $placeholder.show();
                }
            } else {
                // Has selections - hide placeholder
                console.log('Has domain selections, hiding placeholder');
                $selection.removeClass('select2-selection--placeholder');
                $placeholder.hide();
            }
        }, 10);
    });

    // Add event handler for evidence type to manage placeholder visibility and has-selections class
    $('#evidenceType').on('change', function() {
        const $select = $(this);
        const selectedValues = $select.val() || [];
        const $container = $select.closest('.select-wrapper, .evidence-type');
        
        // Manage has-selections class
        // Consider it as having selections if there are any actual type selections (not just empty)
        // When "All" is selected, selectedValues will contain both "all" and actual type slugs
        const hasActualSelections = selectedValues.length > 0 && 
            (selectedValues.some(val => val !== 'all') || selectedValues.includes('all'));
        
        if (hasActualSelections) {
            console.log('Adding has-selections class - valid type selections made');
            $container.addClass('has-selections');
        } else {
            console.log('Removing has-selections class - no valid type selections');
            $container.removeClass('has-selections');
        }
        
        setTimeout(function() {
            const $container = $select.siblings('.select2-container');
            const $selection = $container.find('.select2-selection--multiple');
            const $placeholder = $selection.find('.select2-selection__placeholder');
            
            if (selectedValues.length === 0) {
                // No selections - show placeholder
                console.log('No type selections, showing placeholder');
                $selection.addClass('select2-selection--placeholder');
                if ($placeholder.length === 0) {
                    const $newPlaceholder = $('<span class="select2-selection__placeholder">Select</span>');
                    $selection.prepend($newPlaceholder);
                } else {
                    $placeholder.show();
                }
            } else {
                // Has selections - hide placeholder
                console.log('Has type selections, hiding placeholder');
                $selection.removeClass('select2-selection--placeholder');
                $placeholder.hide();
            }
        }, 10);
    });
    
    // Check if there are any evidence items
    var userHasEvidence = $('#userEvidenceTable td a').length;
    if (userHasEvidence == 0) {
        $('#userEvidenceTable').hide();
    }

    // Initialize Bootstrap tooltips for evidence table (domains and types).
    // Delegated on the table (Bootstrap `selector`): evidence-table-init.js makes
    // it a simple-datatables table (20 rows/page), which re-renders the row
    // nodes on every page change/sort/search, so tooltips bound per span only
    // worked on page 1 until the first redraw. Per-span instances (script.js
    // binds every [data-bs-toggle="tooltip"] at load) are disposed first so the
    // delegated config (customClass etc.) is the one that applies.
    var evidenceTableEl = document.getElementById('userEvidenceTable');
    if (evidenceTableEl) {
        [].slice.call(evidenceTableEl.querySelectorAll('span[data-bs-toggle="tooltip"]')).forEach(function (el) {
            var existingTip = bootstrap.Tooltip.getInstance(el);
            if (existingTip) {
                existingTip.dispose();
            }
        });
        new bootstrap.Tooltip(evidenceTableEl, {
            selector: 'span[data-bs-toggle="tooltip"]',
            placement: 'top',
            fallbackPlacements: ['top', 'top', 'top'], // Force top placement
            boundary: 'viewport',
            customClass: 'evidence-domains-tooltip'
        });
    }

    // Ajax form submission for new evidence with direct S3 upload
    $('#newEvidenceForm').submit(function(e) {
        e.preventDefault();
        var $form = $(this);
        var $submitButton = $form.find('button[type="submit"]');
        var fileInput = $('#evidenceFile')[0];
        // Use persisted array from evidence-upload.js (single source of truth; avoids double-upload from input sync)
        var rawFiles = (typeof window.getNewEvidenceSelectedFiles === 'function' && window.getNewEvidenceSelectedFiles().length > 0)
            ? window.getNewEvidenceSelectedFiles()
            : (fileInput && fileInput.files && fileInput.files.length ? Array.from(fileInput.files) : []);
        // Never upload the same file name more than once (case-insensitive; first occurrence wins)
        var seenNames = {};
        var filesToUpload = rawFiles.filter(function(f) {
            var k = (f.name || '').toLowerCase();
            if (seenNames[k]) return false;
            seenNames[k] = true;
            return true;
        });
        var hasFiles = filesToUpload.length > 0;

        // Show loading state
        $submitButton.attr('disabled', 'disabled').html('<i class="fas fa-spinner fa-spin me-1"></i> Creating Evidence...');
        
        // Create FormData object (without files - they'll be uploaded separately)
        var formData = new FormData();
        formData.append('action', 'submit_new_evidence');
        formData.append('evidenceName', $('#evidenceName').val());
        formData.append('evidenceStatus', $('input[name="evidenceStatus"]').val());
        const evidenceDomainValues = $('#evidenceDomain').val();
        console.log('Evidence domain values for submission:', evidenceDomainValues);
        formData.append('evidenceDomain', JSON.stringify(evidenceDomainValues));
        const evidenceTypeValues = $('#evidenceType').val();
        console.log('Evidence type values for submission:', evidenceTypeValues);
        formData.append('evidenceType', JSON.stringify(evidenceTypeValues));
        formData.append('evidenceOwner', $('#evidenceOwner').val());
        formData.append('expirationSchedule', $('#expirationSchedule').val());
        formData.append('expirationDate', $('input[name="expirationDate"]').val());
        formData.append('evidenceNotes', $('#evidenceNotes').val());
        formData.append('associatedProjects', JSON.stringify($('#associatedProjects').val()));
        formData.append('associatedSafeguards', '');
        formData.append('autoAssignProjectUsers', $('#autoAssignProjectUsers').is(':checked'));
        formData.append('uploadDate', $('input[name="uploadDate"]').val());
        formData.append('creationDate', new Date().toISOString().slice(0, 19).replace('T', ' '));
        formData.append('nonce', evidenceData.nonce);
        // Flag to tell server not to expect files in this request
        formData.append('skip_file_upload', hasFiles ? 'true' : 'false');

        // Log form data for debugging
        console.log('DEBUG: FormData prepared for submission (files will be uploaded separately via S3).');
        
        // Ajax POST request with FormData (without files)
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            },
            success: function(response) {
                console.log('Server response:', response);
                if (response.success) {
                    const evidenceId = response.data.evidence_id;
                    console.log('Evidence created with ID:', evidenceId);
                    
                    // If we have files, upload them using DirectS3Uploader
                    if (hasFiles && typeof window.DirectS3Uploader !== 'undefined') {
                        uploadFilesWithProgress(filesToUpload, evidenceId, $submitButton);
                    } else if (hasFiles) {
                        // Fallback: upload files traditionally if DirectS3Uploader not available
                        console.warn('DirectS3Uploader not available, using fallback upload');
                        uploadFilesTraditional(filesToUpload, evidenceId, $submitButton);
                    } else {
                        // No files, handle project associations and reload
                        handleProjectAssociationsAndReload(evidenceId, $submitButton);
                    }
                } else {
                    console.error('Server returned error:', response.data);
                    alert('Error: ' + (response.data.message || 'Unknown error occurred'));
                    $submitButton.removeAttr('disabled').text('Create Evidence');
                }
            },
            error: function(xhr, status, error) {
                console.error('=== AJAX ERROR DEBUG ===');
                console.error('Status:', status);
                console.error('Error:', error);
                console.error('Response Text:', xhr.responseText);
                alert('Error ' + xhr.status + ': ' + xhr.statusText + '\n\nCheck console for detailed error information.');
                $submitButton.removeAttr('disabled').text('Create Evidence');
            }
        });
    });

    // Function to upload files with progress using DirectS3Uploader
    function uploadFilesWithProgress(files, evidenceId, $submitButton) {
        console.log('Starting file upload with DirectS3Uploader for evidence:', evidenceId);
        
        // Update button text
        $submitButton.html('<i class="fas fa-spinner fa-spin me-1"></i> Uploading files...');
        
        // Initialize progress UI for files
        initializeNewEvidenceProgressUI(files);
        
        // Create uploader instance
        const uploader = new window.DirectS3Uploader({
            ajaxUrl: evidenceData.ajax_url,
            nonce: evidenceData.nonce,
            concurrency: 5,
            maxRetries: 3,
            
            onFileProgress: function(index, fileData) {
                updateNewEvidenceFileProgress(index, fileData);
            },
            
            onFileComplete: function(index, fileData) {
                updateNewEvidenceFileProgress(index, fileData);
            },
            
            onFileError: function(index, fileData) {
                updateNewEvidenceFileProgress(index, fileData);
            },
            
            onOverallProgress: function(progress) {
                const percent = progress.percentComplete;
                $submitButton.html(`<i class="fas fa-spinner fa-spin me-1"></i> Uploading ${progress.completed}/${progress.total} (${percent}%)`);
            },
            
            onAllComplete: function(results) {
                console.log('File upload complete:', results);
                
                if (results.failed > 0) {
                    console.warn(`${results.failed} file(s) failed to upload`);
                }
                
                // Handle project associations and reload
                handleProjectAssociationsAndReload(evidenceId, $submitButton);
            }
        });
        
        // Store uploader reference for potential cancellation
        window.newEvidenceUploader = uploader;
        
        // Start the upload
        uploader.uploadFiles(files, evidenceId);
    }
    
    // Initialize progress UI for new evidence files
    function initializeNewEvidenceProgressUI(files) {
        const $fileList = $('#newEvidenceFileList');
        
        // Update existing file items with progress bars
        $fileList.find('.file-item').each(function(index) {
            const $item = $(this);
            
            // Remove existing progress elements
            $item.find('.upload-progress-wrapper').remove();
            
            // Hide the remove button during upload
            $item.find('.remove-file').hide();
            
            // Add full-width progress bar at the bottom
            $item.css({
                'flex-wrap': 'wrap',
                'padding-bottom': '0'
            });
            
            $item.append(`
                <div class="upload-progress-wrapper w-100 mt-2">
                    <div class="progress" style="height: 6px; border-radius: 0 0 4px 4px;">
                        <div class="progress-bar" role="progressbar" style="width: 0%"></div>
                    </div>
                </div>
            `);
        });
    }
    
    // Update file progress UI for new evidence
    function updateNewEvidenceFileProgress(index, fileData) {
        const $item = $('#newEvidenceFileList .file-item').eq(index);
        if (!$item.length) return;
        
        const $progressBar = $item.find('.progress-bar');
        
        // Update progress bar width
        $progressBar.css('width', fileData.progress + '%');
        
        const StatusMap = window.FileUploadStatus || {
            PENDING: 'pending',
            GETTING_URL: 'getting_url',
            UPLOADING: 'uploading',
            COMPLETE: 'complete',
            ERROR: 'error',
            CANCELLED: 'cancelled'
        };
        
        switch (fileData.status) {
            case StatusMap.PENDING:
            case 'pending':
                $progressBar.removeClass().addClass('progress-bar bg-secondary');
                break;
            case StatusMap.GETTING_URL:
            case 'getting_url':
                $progressBar.removeClass().addClass('progress-bar bg-info progress-bar-striped progress-bar-animated');
                break;
            case StatusMap.UPLOADING:
            case 'uploading':
                $progressBar.removeClass().addClass('progress-bar bg-primary');
                break;
            case StatusMap.COMPLETE:
            case 'complete':
                $progressBar.removeClass().addClass('progress-bar bg-success').css('width', '100%');
                break;
            case StatusMap.ERROR:
            case 'error':
                $progressBar.removeClass().addClass('progress-bar bg-danger');
                break;
            case StatusMap.CANCELLED:
            case 'cancelled':
                $progressBar.removeClass().addClass('progress-bar bg-warning');
                break;
        }
    }
    
    // Fallback traditional upload if DirectS3Uploader not available
    function uploadFilesTraditional(files, evidenceId, $submitButton) {
        const formData = new FormData();
        formData.append('action', 'add_evidence_files');
        formData.append('nonce', evidenceData.nonce);
        formData.append('evidence_id', evidenceId);
        
        for (let i = 0; i < files.length; i++) {
            formData.append('evidenceFiles[]', files[i]);
        }
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    handleProjectAssociationsAndReload(evidenceId, $submitButton);
                } else {
                    alert(response.data.message || 'Error uploading files');
                    handleProjectAssociationsAndReload(evidenceId, $submitButton);
                }
            },
            error: function() {
                console.error('Error uploading files via traditional method');
                handleProjectAssociationsAndReload(evidenceId, $submitButton);
            }
        });
    }
    
    // Redirect to the newly created evidence post
    function redirectToEvidence(evidenceId) {
        const baseUrl = (typeof evidenceData !== 'undefined' && evidenceData.home_url) ? evidenceData.home_url.replace(/\/+$/, '') : (window.location.origin || '');
        window.location.href = baseUrl + '/evidence/' + encodeURIComponent(evidenceId);
    }

    // Handle project associations, then redirect to the new evidence post
    function handleProjectAssociationsAndReload(evidenceId, $submitButton) {
        const associatedProjects = $('#associatedProjects').val();
        
        $submitButton.html('<i class="fas fa-check me-1"></i> Complete!');
        
        if (associatedProjects && associatedProjects.length > 0) {
            console.log('Creating PROJECT_ASSOCIATION_ONLY assignments for projects:', associatedProjects);
            
            let completedAssignments = 0;
            const totalProjects = associatedProjects.length;
            
            associatedProjects.forEach(function(projectSlug) {
                const assignmentData = {
                    projectId: projectSlug,
                    safeguardId: 'PROJECT_ASSOCIATION_ONLY',
                    evidenceId: evidenceId,
                    assignedTo: null,
                    assignedBy: evidenceData.current_user_id
                };
                
                if (typeof window.safeguardAssignment !== 'undefined') {
                    window.safeguardAssignment.createMultipleAssignments([assignmentData], function(success) {
                        completedAssignments++;
                        
                        if (completedAssignments === totalProjects) {
                            console.log('All project associations created, redirecting to evidence');
                            setTimeout(function() {
                                redirectToEvidence(evidenceId);
                            }, 1000);
                        }
                    });
                } else {
                    completedAssignments++;
                    if (completedAssignments === totalProjects) {
                        setTimeout(function() {
                            redirectToEvidence(evidenceId);
                        }, 1000);
                    }
                }
            });
        } else {
            console.log('No associated projects, redirecting to evidence');
            setTimeout(function() {
                redirectToEvidence(evidenceId);
            }, 1000);
        }
    }

    // Function to trigger confetti
    window.triggerConfetti = function() {
        var confettiSettings = { target: 'confettiCanvas' };
        var confetti = new ConfettiGenerator(confettiSettings);
        confetti.render();

        // Auto-destroy the confetti after 5 seconds
        setTimeout(() => {
            confetti.clear();
        }, 5000);
    };

    // Handle evidence no-access links
    $(document).on('click', '.evidence-no-access-link', function(e) {
        e.preventDefault();
        console.log('Evidence no-access link clicked');
        
        // Show the no access modal
        $('#evidenceNoAccessModal').modal('show');
    });

    // Global function to show no-access modal (for action buttons)
    window.showNoAccessModal = function() {
        console.log('No access modal triggered from action button');
        $('#evidenceNoAccessModal').modal('show');
    };

    // Handle auto-assignment preview when projects are selected
    $('#associatedProjects').on('change', function() {
        updateAutoAssignmentPreview();
    });

    // Handle auto-assignment preview when checkbox is toggled
    $('#autoAssignProjectUsers').on('change', function() {
        updateAutoAssignmentPreview();
    });

    // Function to update auto-assignment preview based on both conditions
    function updateAutoAssignmentPreview() {
        const selectedProjects = $('#associatedProjects').val();
        const isAutoAssignChecked = $('#autoAssignProjectUsers').is(':checked');
        
        console.log('Auto-assignment preview update:', {
            selectedProjects: selectedProjects,
            isAutoAssignChecked: isAutoAssignChecked
        });
        
        if (selectedProjects && selectedProjects.length > 0 && isAutoAssignChecked) {
            // Show the auto-assignment preview
            $('#autoAssignmentPreview').show();
            
            // Get preview data
            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'get_evidence_auto_assignment_preview',
                    project_slugs: JSON.stringify(selectedProjects),
                    nonce: $('input[name="nonce"]').val()
                },
                success: function(response) {
                    if (response.success && response.data.preview) {
                        displayAutoAssignmentPreview(response.data.preview);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error getting auto-assignment preview:', error);
                }
            });
        } else {
            // Hide the preview if no projects selected or checkbox not checked
            $('#autoAssignmentPreview').hide();
        }
    }

    // Function to display auto-assignment preview
    function displayAutoAssignmentPreview(preview) {
        const previewContent = $('#previewContent');
        let html = '';
        
        if (preview.total_users === 0) {
            html = '<p class="text-muted mb-0">No project owners or admins found for the selected projects.</p>';
        } else {
            // Combine all users into a single list
            const allUsers = [];
            if (preview.project_owners && preview.project_owners.length > 0) {
                allUsers.push(...preview.project_owners);
            }
            if (preview.project_admins && preview.project_admins.length > 0) {
                allUsers.push(...preview.project_admins);
            }
            
            html = '<ul class="list-unstyled mb-0">';
            allUsers.forEach(function(user, index) {
                const isLast = index === allUsers.length - 1;
                const marginClass = isLast ? '' : 'mb-2';
                html += `<li class="${marginClass}">${user.display_name} <small class="text-muted">(${user.user_email})</small></li>`;
            });
            html += '</ul>';
        }
        
        previewContent.html(html);
    }

});
